import t from 'tcomb';

const ReimbursementSummaryCommon = t.struct({
    approvedClaimCount: t.Number,
    id: t.String,
    pipsUnpaidLaborAdditives: t.Number,
    postingDate: t.Number,
    recoveryPercentage: t.Number,
    recoveryWithMissedAdditivesPercentage: t.Number,
    recoveryWithoutAdditivesPercentage: t.Number,
    totalApproved: t.Number,
    totalApprovedWithoutAdditives: t.Number,
    totalRequested: t.Number,
    totalUnpaid: t.Number,
    unpaidLabor: t.Number,
    unpaidLaborAdditivesExcludingPips: t.Number,
    unpaidOtherCredits: t.Number,
    unpaidParts: t.Number,
    unpaidPartsAdditive: t.Number,
    unpaidTravel: t.Number
}, {
    name: 'ReimbursementSummaryCommon',
    strict: true
});

export const getDefaultState = () => new ReimbursementSummaryCommon({
    approvedClaimCount: 0,
    id: '',
    pipsUnpaidLaborAdditives: 0,
    postingDate: 0,
    recoveryPercentage: 0,
    recoveryWithMissedAdditivesPercentage: 0,
    recoveryWithoutAdditivesPercentage: 0,
    totalApproved: 0,
    totalApprovedWithoutAdditives: 0,
    totalRequested: 0,
    totalUnpaid: 0,
    unpaidLabor: 0,
    unpaidLaborAdditivesExcludingPips: 0,
    unpaidOtherCredits: 0,
    unpaidParts: 0,
    unpaidPartsAdditive: 0,
    unpaidTravel: 0
});

export default ReimbursementSummaryCommon;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/reimbursement-summary-common.js